<template>
  <el-dialog custom-class="min-dialog" title="设置/修改密码" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :modal-append-to-body="false">
    <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
      <el-form-item label="手机号：" prop="mobile">
        <el-input v-model="ruleForm2.mobile" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="验证码：" prop="smsiden">
        <el-input v-model="ruleForm2.smsiden" auto-complete="off" style="width: 60%;"></el-input>
        <el-button type="primary" round @click="getCode" :disabled="!canpost">获取验证码{{countName}}</el-button>
      </el-form-item>
      <el-form-item label="密码：" prop="newPassword">
        <el-input type="password" v-model="ruleForm2.newPassword" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="确认密码：" prop="checkPass">
        <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitForm('ruleForm2')" :disabled="hasSubmit">提交</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {registerPerson,sendVerificationCode} from '../../api/login'

  export default {
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } if (value.length<6) {
          callback(new Error('密码长度不能小于6位'));
        } else {
          if (this.ruleForm2.checkPass !== '') {
            this.$refs.ruleForm2.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm2.newPassword) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        hasSubmit:false,
        dialogFormVisible: false,
        countName:'',
        count:60,
        timer:null,
        canpost:true,
        ruleForm2: {
          smsiden:'',
          mobile:'',
          newPassword: '',
          checkPass: '',
        },
        rules2: {
          smsiden: [
            {required: true, message: '请输入验证码', trigger: 'blur'},
          ],
          mobile: [
            {required: true, message: '请输入手机号', trigger: 'blur'},
            {pattern: /^0{0,1}(1[0-9][0-9]|15[7-9]|153|156|18[7-9])[0-9]{8}$/, message: '请输入正确的手机号', trigger: 'blur'},
          ],
          newPassword: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ]
        }
      };
    },
    props: ['tenantid'],
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {   //调用登录接口
            this.hasSubmit=true;
            registerPerson(this.ruleForm2).then(response => {
              if (response.data.code == 0) {//注册成功
                this.$message({
                  message: '设置成功,请用新密码登录！',
                  type: 'success'
                })
                this.$emit("AfterRegister",this.ruleForm2.mobile);
                this.dialogFormVisible=false;
              } else {
                setTimeout(() => {
                  this.hasSubmit=false;
                }, 5000);
                this.$message.error({message: response.data.msg});
              }
            }).catch((error) => {
              console.log(error)
            });
          } else {
            return false;
          }
        });
      },
      getCode(){
        if(this.ruleForm2.mobile=='')
          return;
        const TIME_COUNT = 60;
        if (!this.timer) {
          var self=this;
          self.count = TIME_COUNT;
          if(self.canpost){
            sendVerificationCode({type:'changepw',tenantid:this.tenantid,mobile:this.ruleForm2.mobile}).then(response=>{
              this.$message({
                message: '验证码发送成功！',
                type: 'success'
              })
            });
          }
          self.canpost = false;
          self.timer = setInterval(() => {
            if (self.count > 0 && self.count <= TIME_COUNT) {
              self.count--;
              self.countName='（'+self.count+'s）';
            } else {
              self.canpost = true;
              self.countName='';
              clearInterval(self.timer);
              self.timer = null;
            }
          }, 1000)
        }
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      show(){
        this.ruleForm2.mobile='';
        this.ruleForm2.smsiden='';
        this.ruleForm2.newPassword='';
        this.ruleForm2.checkPass='';
        this.hasSubmit=false;
        this.dialogFormVisible=true;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/login/RegisterPW.vue